import React from 'react';
import MultiClamp from 'react-multi-clamp';
import styled from 'styled-components';

import { TextLink } from '@crehana/ui';
import PriceSmall from '@crehana/ui/dist/Text/PriceSmall';
import { PlusNew } from '@crehana/icons';
import { useTranslation } from '@crehana/i18n';
import { useProductsContainer } from '@crehana/web/dist/ReactContexts/Products';

import LazymageV2 from 'Jsx/Shared/LazyImageV2';

import { SHOPPING_CART_TRANSLATION_KEY } from 'Jsx/Utils/transformKeys';

const Picture = styled.div`
  position: relative;
  width: 200px !important;
  height: 140px !important;
  background-color: #4b22f4;
  margin-right: 16px;
  overflow: hidden;
  flex-shrink: 0;
`;

const ItemCard = ({
  item: { originalId, title, url, prices, promoImage, professor },
}: {
  item: {
    originalId: number;
    title: string;
    url: string;
    prices: {
      currencySymbol: string;
      price: number;
      realPrice: number;
    };
    promoImage: string;
    professor: {
      fullName: string;
    };
  };
}) => {
  const { addCourseToCart, removeCourseFromCart, shoppingCartState } =
    useProductsContainer();
  const courseIsInCart =
    shoppingCartState.courseIdsInCart.indexOf(originalId) !== -1;
  const { t } = useTranslation(SHOPPING_CART_TRANSLATION_KEY);

  return (
    <div>
      <div className="relative flex items-start ">
        <Picture>
          <LazymageV2
            lazyUrl={promoImage}
            imgxParams={{
              w: 200,
              h: 140,
            }}
          />
        </Picture>
        <div className="w-full">
          <div style={{ maxWidth: '82%' }}>
            <p
              onClick={() => {
                window.open(url);
              }}
              className="mb-8 cursor-pointer font-subtitle2"
            >
              <MultiClamp ellipsis="..." clamp={2}>
                {title}
              </MultiClamp>
            </p>
          </div>
          <p className="mb-8 font-body4">{professor.fullName}</p>
          <div className="flex items-center">
            <PriceSmall
              currency={prices.currencySymbol}
              price={prices.price.toLocaleString()}
              discount={
                prices.currencySymbol + prices.realPrice.toLocaleString()
              }
              discountColor="gray-dark"
            />
          </div>
          <TextLink
            label={courseIsInCart ? t('REMOVE_FROM_CART') : t('ADD_TO_CART')}
            type="level2"
            leftIcon={{ component: PlusNew, size: 12, hasStroke: true }}
            className="mt-16 uppercase cursor-pointer"
            // @ts-expect-error idk
            color="secondary-main"
            onClick={() => {
              const course = {
                courseId: originalId,
              };
              const options = {
                preventRedirect: true,
              };

              if (courseIsInCart) {
                removeCourseFromCart(course, options);
              } else {
                addCourseToCart(course, options);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ItemCard;
